
<div :class="{'list-view-filter-base': filterElement.isConfigured || isPreview}">
  <template v-if="filterElement.isConfigured">
    <label
      v-if="isLabelInBase"
      :for="filterElement.idForProp('filter')"
    >
      {{filterElement.label_title}}
    </label>
    <component
      v-if="getComponentByType(filterElement.filter_type)"
      :is="getComponentByType(filterElement.filter_type)"
      :filter-element="filterElement"
      :key="filterElement.id"
    ></component>
  </template>
  <filter-not-configured v-else-if="isPreview" :filter-element="filterElement"></filter-not-configured>
</div>
